import { AddressModel } from './address.model';

export class DeliveriesModel {
    public delivery_address: AddressModel;
    public billing_address: AddressModel;
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/models/payment/deliveries.model.ts